import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useCalculationStore } from '@/stores/calculation'
import { useProjectStore } from '@/stores/project'

export const useCalculationPermissions = () => {
  const calculationStore = useCalculationStore()
  const {
    currentItem: currentCalculation,
    canAddCalculation,
    canStopCalculation,
    canDeleteCalculation
  } = storeToRefs(calculationStore)
  const { currentItem: currentProject } = storeToRefs(useProjectStore())

  const isDemo = computed(
    () => Boolean(currentProject.value?.is_demo) || Boolean(currentCalculation.value?.is_demo)
  )

  return {
    canAddCalculation: computed(() => canAddCalculation.value && !isDemo.value),
    canStopCalculation: computed(() => canStopCalculation.value && !isDemo.value),
    canDeleteCalculation: computed(() => canDeleteCalculation.value && !isDemo.value)
  }
}
